export default __webpack_public_path__ + "static/media/SavingScheme.d2c86bea.png";